import React, { useEffect } from "react"
import { css } from "@emotion/core"
import CenteredLayout from "layouts/Centered"
import Header from "components/Common/Header"
import PageMetadata from "../components/Common/PageMetadata"
import ArticleFull from "../components/ArticleFull"
import SocialShare from "../components/UI/SocialShare"
import FeaturedArticlesSidebar from "../components/FeaturedArticlesSidebar"
import getFeaturedArticles from "../utils/getFeaturedArticles"
import { graphql } from "gatsby"
import linkResolver from "../utils/linkResolver"
import FloatingMenu from "components/UI/FloatingMenu"
import { useMediaQuery } from "react-responsive"
import t from "theme"

export const query = graphql`
    query($slug: String!) {
        article: contentfulArticle(slug: { eq: $slug }) {
            ...ArticleContent
        }
    }
`

const ArticlePage = ({ pageContext: { commonData }, data: { article }, location }) => {
    const featuredArticles =
        article && article.companies
            ? getFeaturedArticles(commonData, article.companies[0].ticker)
            : getFeaturedArticles(commonData)

    const selectedCompany = article && article.companies ? article.companies[0] : null

    const isTabletOrPhone = useMediaQuery({
        query: `(max-width: ${t.breakpoint.large})`,
    })

    return (
        article && (
            <CenteredLayout
                header={
                    <Header
                        commonData={commonData}
                        selectedCompany={selectedCompany}
                        selectedFeature="Articles"
                        pathname={location.pathname}
                    />
                }
                sidebar={<FeaturedArticlesSidebar title="FEATURED ARTICLES" featureds={featuredArticles} />}>
                <PageMetadata pageContent={article} pagePathname={location.pathname} />

                <ArticleFull
                    articleData={article}
                    css={css`
                        margin-bottom: ${t.space[4]};
                    `}
                />
                <SocialShare linkUrl={linkResolver({ slug: article.slug, type: "article" })} />
                {isTabletOrPhone ? <FloatingMenu linkUrl={location.pathname} /> : null}
            </CenteredLayout>
        )
    )
}

export default ArticlePage
